<template>
    <div 
        v-if="svgData"
        :class="svgData.class">
    <svg
        @click="this.$emit('click')"
        :width="emptyString(svgData.width)"
        :height="emptyString(svgData.height)"
        :viewBox="emptyString(svgData.viewBox)"
        :fill-rule="emptyString(svgData.fillRule)"
        :clip-rule="emptyString(svgData.clipRule)"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path v-for="path in emptyArr(svgData.pathArr)" :key="path.p"
            :d="emptyString(path.d)"
            :fill="emptyString(path.fill)">
        </path>
    </svg>
    </div>
</template>

<script>

export default {
    name: 'SvgIcon',
    props: {
        svgData : Object
    },
    emits: ['click'],
    methods: {
        emptyString(str){
            if (str === undefined && typeof str !== "string")
                return ''
            return str
        },
        emptyArr(arr){
            if (arr === undefined && !Array.isArray(arr))
                return []
            return arr
        }
    }
}
</script>